<h1 mat-dialog-title>{{ 'page.widgetContent.addEditDialog.configureWidgetFilter.title' | translate }}</h1>

<div mat-dialog-content>
  <div [class.mb-4]="modeNamesOfWidget.length !== 1">
    <filter-mode-selection-and-ordering-panel
      [filterModeOrder]="filterModeOrder"
      [modeNamesOfWidget]="modeNamesOfWidget"
    >
    </filter-mode-selection-and-ordering-panel>
  </div>

  @for (sectionData of rows; track sectionData.modeName) {
    <div [class.mb-4]="sectionData.filters.length">
      <configure-filters-of-a-mode-panel
        [modeName]="sectionData.modeName"
        [configurationsOfAdvancedFilterInputs]="sectionData.filters"
        [typeBasedConfiguration]="injectData.widgetTypeBasedConfiguration"
        [widgetType]="injectData.widgetType"
        [filterSuppression]="sectionData.matchingFilterSuppression"
      >
      </configure-filters-of-a-mode-panel>
    </div>
  }
</div>

<mat-dialog-actions align="end">
  <button matButton="tonal" type="button" mat-dialog-close>
    {{ 'button.cancel' | translate }}
  </button>
  <button mat-flat-button type="button" (click)="apply()">
    {{ 'button.apply' | translate }}
  </button>
</mat-dialog-actions>
